module.exports = __webpack_public_path__ + "static/media/closed-icon.275c7711.svg";